export default "__VITE_ASSET__pOpkSShV__"